.loading { display: flex; align-items: center; justify-content: center; gap: 12px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.pulse { width: 10px; height: 10px; background: var(--pink); animation: pulse 1s ease-in-out infinite alternate; }
@keyframes pulse { from { opacity: 0.3; } to { opacity: 1; } }
.empty, .error { display: flex; flex-direction: column; align-items: flex-start; gap: 10px; padding: 28px 22px; }
.error { background: var(--hot-8); border: 1.5px solid var(--hot); }
.title { font-family: var(--font-cond); font-size: 28px; font-weight: 900; letter-spacing: -1px; }
.body { margin: 0; font-size: 13px; line-height: 1.45; color: var(--text-secondary); }
@media (max-width: 639px) {
  .empty, .error { padding: 24px 16px; }
  .error :global(.btn) { width: 100%; }
}
